<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Quadro de Horário - Sala Especial" />
        <div v-if="dadosAba">
            <div v-if="$featureToggle && $featureToggle.INTEGRA_QUADROHORARIO_SALASESPECIAIS">
                <Grid v-bind:Data="dadosAba.quadroHorario.salasEspeciais"
                      v-bind:Header="headerSalaEspecial"
                      Name="SalaEspecial"
                      Title="Total"
                      OrderBy="periodoLetivo"
                      v-bind:HeaderDetalhes="headerDetalhe"
                      v-bind:DetalhesCombo1="null"
                      v-bind:DetalhesCombo2="null"
                      v-bind:DetalhesCombo3="null" />
            </div>
        </div>
    </Loading>
</template>

<script>
    import Grid from '@/components/Grid';
    import QuadroHorario from '@/services/QuadroHorarioService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

    export default {
        name: 'QuadroHorarioSalaEspecial',
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.QuadroHorarioSalaEspecial) {
                        this.dadosAba = a.QuadroHorario;
                    }
                }
                else
                    this.$router.push('home');
            }

            this.quadroHorarioService = new QuadroHorario(this);

            //Verifica se a aba não está carregada
            if (!this.dadosAba) {
                //Popula os dados da aba
                this.showLoading = true;
                this.quadroHorarioService.ObterQuadroHorarioAluno({
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoPeriodo: this.aluno.codigoPeriodoSituacao,
                    CodigoEmpresa: this.aluno.codigoEmpresa,
                    CodigoTurma: this.aluno.codigoTurma
                }).then(
                    data => {
                        if (data.ok) {
                            this.dadosAba = data.dados;

                            this.semestralizadoDetalhes();
                        }
                        else {
                            this.$modal.info(data.Mensagem);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.QuadroHorarioSalaEspecial = this.dadosAba;
            sessionStorage.setItem("QuadroHorario", JSON.stringify(aluno));
        },
        data() {
            return {
                expandPrincipal: true,
                expandInfo: true,
                aluno: null,
                showLoading: false,

                headerDetalhe: [
                    {
                        Titulo: "Horário de aula",
                        Field: "descricaoHorarioAgrupadoPorDia",
                        Tipo: "texto"
                    }
                ],

                headerSalaEspecial: [
                    {
                        Titulo: "Disciplina",
                        Field: "descricaoCompleta",
                        Width: "200px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Sala",
                        Field: "codigoSalaEspecial",
                        Width: "50px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Turma Sala",
                        Field: "turmaSalaEspecial",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    //{
                    //    Titulo: "Carga Horária",
                    //    Field: "cargaHoraria",
                    //    Width: "60px",
                    //    Tipo: "number"
                    //},
                    {
                        Titulo: "Data Análise",
                        Field: "dataAnaliseSala",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Encerramento",
                        Field: "dataEncerramentoMat",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Início Aula",
                        Field: "dataInicioAula",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Situação Aluno",
                        Field: "situcaoAlunoSalaEspecialDescricao",
                        Width: "80px",
                        Tipo: "texto"
                    }
                ],

                dadosAba: null,
                salaEspecialClasse: 'md-raised md-warning',
                semestralizado: null,
                exibirHistoricoAceite: false
            }
        },
        methods: {

            carregarHistoricoAceite() {
                this.exibirHistoricoAceite = !this.exibirHistoricoAceite;
            },

            semestralizadoDetalhes() {
                switch (this.dadosAba.quadroHorario.semestralizado.codigo) {
                    case "NOR": this.semestralizado = { theme: 'primary' }; break; //Cursando
                    default: this.semestralizado = { theme: 'warning' }; break;
                }
            }
        }
    }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .full-control {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
    }

    .list {
        width: 320px;
    }

    .titulo {
        margin: 0;
        padding: 0 0 0 15px;
        font-weight: bold;
    }


    .divHorario {
        float: left;
        position: relative;
        display: inline;
        width: 300px;
        padding: 0 10px 10px 10px;
    }

    .divCargaHoraria {
        width: 400px;
        float: left;
        position: relative;
        display: inline;
        padding: 0 0 0 30px
    }


    .divHistoricoAceite {
        z-index: 1000;
        width: 90%;
        height: 500px;
        overflow-y: auto;
        padding: 20px;
    }

    .buttonHistoricoAceite {
        background-color: #8629ff;
        border-radius: 5px;
        color: #fff;
        font-size: 13px;
        margin-top: 10px;
        padding: 10px;
        font-weight: bold;
    }

    .iconeHistoricoAceite {
        color: #fff !important;
        padding: 0 20px 0 20px;
    }

    .semestralizado {
        width: 218px;
        margin-left: 1px;
        padding-top: 0px;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
